import { cn } from '@/lib/utils';
import { expirationLevel } from '@/features/certificates/schemas';

interface Props {
  daysToExpire: number;
  totalDays?: number;
  className?: string;
}

const LEVEL_CLASS = {
  ok: 'bg-emerald-500',
  warning: 'bg-amber-500',
  danger: 'bg-red-500',
} as const;

export function ExpirationBar({ daysToExpire, totalDays = 365, className }: Props) {
  const level = expirationLevel(daysToExpire);
  const pct = Math.max(0, Math.min(100, (daysToExpire / totalDays) * 100));
  const label =
    daysToExpire <= 0
      ? 'Expirado'
      : `Expira em ${daysToExpire} ${daysToExpire === 1 ? 'dia' : 'dias'}`;

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={totalDays}
        aria-valuenow={Math.max(0, daysToExpire)}
        aria-label={label}
        data-level={level}
        className="h-2 w-full overflow-hidden rounded-full bg-(--color-border)"
      >
        <div
          className={cn('h-full rounded-full transition-all', LEVEL_CLASS[level])}
          style={{ width: `${pct}%` }}
        />
      </div>
      <p
        className={cn(
          'text-xs font-medium',
          level === 'danger' && 'text-red-600 dark:text-red-400',
          level === 'warning' && 'text-amber-600 dark:text-amber-400',
          level === 'ok' && 'text-(--color-fg-muted)',
        )}
      >
        {label}
      </p>
    </div>
  );
}
